<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :class="isUrl('account') ? 'text-white' : 'text-indigo-300 hover:text-white'" href="/account">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('account') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div>Le mie prenotazioni</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :class="isUrl('account/profile') ? 'text-white' : 'text-indigo-300 hover:text-white'" href="/account/profile">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('account/profile') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div>Profilo</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3 text-indigo-300 hover:text-white" href="/checkout?returnUrl=/account">
        <icon name="printer" class="mr-2 w-4 h-4 fill-indigo-400 group-hover:fill-white" />
        <div>Nuova Prenotazione</div>
      </Link>
    </div>
  </div>
</template>

<script>
import Icon from "@/Pages/Dashboard/Shared/Icon.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(expectedPath) {
      const currentPath = window.location.pathname;

      // Handle account root specially
      if (expectedPath === 'account' || expectedPath === '/account') {
        return currentPath === '/account';
      }

      const normalized = expectedPath.startsWith('/') ? expectedPath : `/${expectedPath}`;
      return currentPath.startsWith(normalized);
    },
  },
};
</script>
